import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import moment from 'moment';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import { AddSearchFlightFDDispatch } from '../reducers/FDReducer';
import {
	addBusSearchDispatch,
	fetchBusCityDesDispatch,
	fetchSeatLayoutDispatch,
} from '../reducers/BusReducer';
import {
	setHolidayDes,
	setSelectedBusArr,
	setSelectedBusDepart,
	setSelectedTripID,
} from '../reducers/UiReducer';
import { Showseat } from '../components/resuableComponents/ShowSeat';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import {
	fetchAllLocationDispatch,
	fetchAllPackageDispatch,
} from '../reducers/PackageReducer';
const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const SearchResultHolidays = () => {
	const { city, loadinghome } = useSelector((state) => state.home);
	const { busSearch, layoutloading, seatLayout, buscity, busDes } = useSelector(
		(state) => state.bus
	);
	const { locationresult } = useSelector((state) => state.package);
	const { tripid, busDepart, busArr } = useSelector((state) => state.ui);
	const { packageresult } = useSelector((state) => state.package);
	const dispatch = useDispatch();
	// const navigate = useNavigate();
	const [departDate, setDepartDate] = useState('');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [filterDataD, setFilterDataD] = useState('');
	const [filterData2, setFilterData2] = useState('');
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	function timeConvertbus(a) {
		let arhour = Math.floor(a / 60);
		if (arhour > 24) {
			arhour = arhour - 24;
		}
		let armin = a % 60;
		let format = `${arhour}:${armin === 0 ? '00' : armin}:00`;
		function formatTime(timeString) {
			const [hourString, minute] = timeString.split(':');
			const hour = +hourString % 24;
			return (hour % 12 || 12) + ':' + minute + (hour < 12 ? ' AM' : ' PM');
		}
		return formatTime(format);
		console.log('first', armin);
	}
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const handleChange = (value) => {
		let form2 = {
			keywords: value.toLowerCase(),
		};
		dispatch(fetchAllLocationDispatch(form2));
		dispatch(setHolidayDes(form2));
	};
	const opsList =
		locationresult?.result?.length > 0 &&
		locationresult?.result?.map((l) => {
			return <Option value={`${l.location}`}>{`${l.location}`}</Option>;
		});
	const handleChange2 = (value) => {
		let results = [];
		results =
			busDes &&
			busDes?.result &&
			busDes?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (value) {
			dispatch(setSelectedBusArr(value));
		}
		if (results?.length < 80) {
			setFilterData2(results);
		}
	};
	const opsList2 =
		filterData2?.length > 0 &&
		filterData2?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});
	let filterData = [];
	filterData =
		busSearch &&
		busSearch.result &&
		busSearch.result.availableTrips &&
		busSearch.result.availableTrips.length > 0 &&
		busSearch.result.availableTrips.slice().sort((a, b) => {
			let first = Array.isArray(a?.fares) ? a?.fares[0] : a.fares;
			let second = Array.isArray(b?.fares) ? b?.fares[0] : b.fares;
			return first - second;
		});
	console.log('fILTER', filterData);
	const handleSubmit = () => {
		navigate('/searchresultholidays');
	};
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	useEffect(() => {
		// dispatch(addBusSearchDispatch(location.state));
		dispatch(fetchAllPackageDispatch(location.state));
		// dispatch(AddSearchFlightFDDispatch(location.state));
	}, [location.state]);
	return (
		<div>
			<Navbar />
			{packageresult?.result?.length > 0 ? (
				<>
					<Box style={{ background: '#721053', padding: 20 }}>
						<Container>
							<Grid container spacing={3}>
								<Grid item xs={12} lg={1}></Grid>
								<Grid item xs={12} lg={4}>
									<AutoComplete
										style={{ width: '100%' }}
										dropdownMenuStyle={{
											maxHeight: 1000,
											overflowY: 'visible',
										}}
										placeholder='Where do you want to travel?'
										onClick={(e) => console.log('val', e.target.value)}
										onChange={handleChange}>
										{opsList}
									</AutoComplete>
								</Grid>
								<Grid item xs={12} lg={3}>
									<DatePicker
										picker='month'
										disabledDate={disabledDate}
										style={{ width: '100%', padding: 9 }}
									/>
								</Grid>
								<Grid item xs={12} lg={3}>
									<Button
										onClick={handleSubmit}
										variant='contained'
										style={{
											width: '100%',
											background: 'orange',
											fontWeight: 'bold',
											padding: '7px',
										}}>
										Search
									</Button>
								</Grid>
								<Grid item xs={12} lg={1}></Grid>
							</Grid>
						</Container>
					</Box>
					<Box
						style={{
							background: '#FFF',
							boxShadow: '0 0 10px rgba(0,0,0,.3)',

							paddingTop: 10,
						}}>
						<Container>
							{/* <Grid container spacing={2}>
								<Grid item xs={4}>
									<Box>
										<span>Bus Type</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>AC</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>Non-AC</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>Seat</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>Sleeper</span>
										</Box>
									</Box>
								</Grid>
								<Grid item xs={8}>
									<Box>
										<span>Timing</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												5AM TO 12PM (Morning)
											</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												12PM TO 5PM (Afternoon)
											</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												5PM TO 10PM (Evening)
											</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												10PM TO 5AM (Overnight)
											</span>
										</Box>
									</Box>
								</Grid>
							</Grid> */}
						</Container>
					</Box>
				</>
			) : (
				''
			)}

			<Container>
				<Box
					style={{
						marginTop: 50,
						marginBottom: 50,
						paddingLeft: 100,
						paddingRight: 100,
					}}>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						{/* <h2 style={{ fontSize: 20 }}>{`Bus From ${
							location.state.departure_city
						} to ${location.state.arrival_city}(${
							filterData?.length ? filterData?.length : ''
						})`}</h2>
						<h3 style={{ fontSize: 20 }}>{location.state.dateofjourney}</h3> */}
					</Box>
					<Grid container spacing={4}>
						<Grid item xs={12} lg={12}>
							<InfiniteScroll
								dataLength={scrollVal}
								next={fetchMoreData}
								hasMore={hasMorefilterData}
								loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
								endMessage={
									<p style={{ textAlign: 'center' }}>
										<b>No More Flights</b>
									</p>
								}>
								{packageresult?.result?.length > 0 &&
									packageresult?.result?.map((item, index) => {
										return index < scrollVal ? (
											<>
												<Box
													style={{
														// display: 'flex',
														// justifyContent: 'space-between',
														alignItems: 'center',
														borderRadius: 4,
														background: '#fff',
														filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
														padding: 30,
														marginTop: 10,
													}}>
													<Grid container alignItems={'center'} spacing={4}>
														<Grid item xs={12} lg={4}>
															<Box>
																<img
																	src={item.image}
																	style={{ height: '100%', borderRadius: 5 }}
																/>
															</Box>
														</Grid>
														<Grid item xs={12} lg={4}>
															<Box
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	// alignItems: 'center',
																}}>
																<Box>
																	<span style={{ fontSize: 18 }}>
																		{item.title}
																	</span>
																	<br></br>
																	<span
																		style={{
																			fontSize: 14,
																			color: 'rgba(0,0,0,.38)',
																		}}>
																		Travel{' '}
																		<span
																			style={{
																				color: 'black',
																				fontWeight: 'bold',
																			}}>
																			{item.day}{' '}
																		</span>
																		days{' '}
																		<span
																			style={{
																				color: 'black',
																				fontWeight: 'bold',
																			}}>
																			{item.night}
																		</span>{' '}
																		nights
																		{/* {location.state.departure_city} */}
																	</span>
																	<br></br>
																	<span style={{ fontSize: 20 }}>
																		{' '}
																		{/* {timeConvertbus(item.departureTime)} */}
																	</span>
																</Box>
															</Box>
															<Box
																mt={1}
																style={{
																	display: 'flex',
																	// justifyContent: 'space-between',
																	// alignItems: 'center',
																}}>
																<img
																	src='https://cdn-icons-png.flaticon.com/512/3125/3125713.png'
																	style={{ height: 30, width: 30 }}
																/>
																<img
																	src='https://png.pngtree.com/png-vector/20190623/ourmid/pngtree-hotel-icon-png-image_1511479.jpg'
																	style={{
																		height: 30,
																		width: 30,
																		marginLeft: 5,
																	}}
																/>
																<img
																	src='https://cdn-icons-png.flaticon.com/512/5159/5159840.png'
																	style={{
																		height: 30,
																		width: 30,
																		marginLeft: 5,
																	}}
																/>
																<img
																	src='https://cdn-icons-png.flaticon.com/512/5030/5030991.png'
																	style={{
																		height: 30,
																		width: 30,
																		marginLeft: 5,
																	}}
																/>
															</Box>
														</Grid>
														<Grid item xs={12} lg={4}>
															<Box
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																}}>
																<h2 style={{ fontSize: 26 }}>₹{item.amount}</h2>
																<Button
																	onClick={() =>
																		navigate('/holidaysbooking', {
																			state: item,
																		})
																	}
																	style={{
																		background: '#EC5B24',
																		color: 'white',
																		width: '100%',
																		marginLeft: 20,
																	}}>
																	View Details
																</Button>
															</Box>
															<Box
																mt={2}
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																}}>
																<Button
																	style={{
																		background: 'rgb(222 222 222)',
																		width: '100%',
																		marginLeft: 20,
																	}}>
																	Quick Quote
																</Button>
																<Button
																	style={{
																		background: 'rgb(255 255 255)',
																		width: '100%',
																		marginLeft: 20,
																		border: '1px solid',
																	}}>
																	Enquiry Now
																</Button>
															</Box>
														</Grid>
													</Grid>
													{/* {item.id === tripid && layoutloading ? (
														<h4 style={{ textAlign: 'center' }}>Loading...</h4>
													) : (
														''
													)}

													{layoutloading ? (
														''
													) : item.id === tripid ? (
														<Showseat seatLayout={seatLayout} item={item} />
													) : (
														''
													)} */}
												</Box>
											</>
										) : (
											Array.from(Array(10)).map((i) => {
												return <FlightResultSkeleton />;
											})
										);
									})}
							</InfiniteScroll>
						</Grid>
					</Grid>
				</Box>
			</Container>
			<TopDrawer draw={draw} setDraw={setDraw} />
			<Footer />
		</div>
	);
};

export default SearchResultHolidays;
